// Mirror of the BE helper in services/chatbot_rag/language.py — keep the
// two heuristics in sync so the same query bucket label appears in both
// GA4 events (this file) and chatbot_retrieval_logs (BE). Two-language
// world: TR vs EN. Any Turkish-specific character flips the label to TR.

const TR_SPECIFIC_CHARS = /[şçığüöŞÇİĞÜÖı]/;

export const detectQueryLanguage = (query: string): "tr" | "en" => {
  if (!query || !query.trim()) return "en";

  return TR_SPECIFIC_CHARS.test(query) ? "tr" : "en";
};
